class AddTimeView {

    constructor(onChangeSelectionFn,
                onChangeInputFn,
                onAddTimeFn) {
        this.rootNode = $('#addtime');
        this.dropdownToggle = this.rootNode.find('.dropdown-toggle');
        this.rootNode.find('.dropdown-item').click(onChangeSelectionFn);
        this.doneButton = this.rootNode.find('.btn-done');
        this.doneButton.click(function() {
            this.close();
            onAddTimeFn();
        }.bind(this));

        this.rootNode.find('.btn-close').click(this.close.bind(this));

        this.otherActivityNameDiv = this.rootNode.find('.other-activity-name-group');
        this.otherActivityNameInput = this.rootNode.find('#other-activity-name');
        this.otherActivityNameInput.bindChangedHandler(onChangeInputFn);
    }

    show() {
        this.rootNode.modal('show');
        $('.modal-backdrop').addClass('transparent');
    }

    close() {
        this.rootNode.modal('hide');
        $('.modal-backdrop').removeClass('transparent');
    }
}
